var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5153",
    "data-name": "Group 5153",
    transform: "translate(-1007 -1362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    transform: "translate(1013 1368)",
    fill: "#e52f77",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(1025.139 1387.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15055",
    "data-name": "Path 15055",
    d: "M34.846,76.259a.782.782,0,0,1-.144,1.557A12.06,12.06,0,0,0,22.625,84.79a.779.779,0,0,1-1.413-.654,13.6,13.6,0,0,1,13.634-7.877ZM74.072,91.044a.782.782,0,0,1-.641-1.426l2.761-1.256a.776.776,0,0,1,1.034.393.787.787,0,0,1-.393,1.034Zm-2.224-2a.784.784,0,1,1-1.518-.393l.536-2.015a.784.784,0,1,1,1.518.393Zm2.473,5.744a.786.786,0,0,1,.536-1.479l2.761,1.007a.786.786,0,1,1-.536,1.479Zm-3.389,1.649a.785.785,0,0,1,1.57,0v3.127a.785.785,0,1,1-1.57,0Zm-3.415-.707a.775.775,0,0,1,1.073-.288.8.8,0,0,1,.288,1.073L67.4,99.078a.775.775,0,0,1-1.073.288.786.786,0,0,1-.288-1.073ZM34.505,106.994l-.746-5.979-.013-.2V97.809A1.634,1.634,0,0,1,35.4,96.2h1.819a1.631,1.631,0,0,1,1.636,1.609v3.009l-.013.2-.733,5.979a1.651,1.651,0,0,1-1.636,1.426,1.8,1.8,0,0,1-1.4-.406A1.566,1.566,0,0,1,34.505,106.994Zm.811-6.163.759,5.993c.026.013.458.052.458-.026l.733-5.966L37.253,97.8a.1.1,0,0,0-.065-.026H35.369l-.065.039C35.317,98.607,35.225,100.151,35.317,100.831Zm1.963,0ZM33.89,113.209v-1.5a1.634,1.634,0,0,1,1.649-1.609H37.1a1.631,1.631,0,0,1,1.636,1.609v1.5a1.631,1.631,0,0,1-1.636,1.609H35.539A1.634,1.634,0,0,1,33.89,113.209Zm1.57-1.5.013,1.531a.1.1,0,0,0,.065.026H37.1l.065-.039-.013-1.531a.1.1,0,0,0-.065-.026H35.526ZM40.8,92.627l5.652,9.8a17.256,17.256,0,0,0,4.135-15.976.791.791,0,0,1,.366-.864l1.6-.929-4.462-7.746L46.36,77.921a.789.789,0,0,1-.942-.079,17.236,17.236,0,1,0-20.856,27.307l7.222-12.522A5.2,5.2,0,0,1,40.8,92.627Zm6.477,11.2,4.239,7.353a5.19,5.19,0,0,1-4.5,7.8H25.582a5.189,5.189,0,0,1-4.5-7.8l2.708-4.684A18.8,18.8,0,1,1,46.032,76.3l1.282-.733a2.315,2.315,0,0,1,.824-3.179l2.852-1.649a2.307,2.307,0,0,1,3.179.89l2.512,4.357c2.6-2.591,7.288-2.525,9.46.406a6.335,6.335,0,0,1,.916,5.194c-.092.445-.183.811-.262,1.178-.432,1.832-.877,3.781-.052,5.535a6.275,6.275,0,0,0,4.972,3.559.783.783,0,0,1-.17,1.557,7.827,7.827,0,0,1-6.228-4.449c-1.06-2.25-.536-4.475-.052-6.568.092-.419.2-.824.262-1.125,1.2-5.9-5.391-7.026-8.021-3.873l2.839,4.92a2.307,2.307,0,0,1-.89,3.179l-2.813,1.622a2.317,2.317,0,0,1-3.166-.85l-.144-.249-1.1.628a18.852,18.852,0,0,1-.327,9.237,18.553,18.553,0,0,1-4.632,7.942Zm2.879,8.138L39.438,93.4a3.63,3.63,0,0,0-6.293,0L22.429,111.966a3.631,3.631,0,0,0,3.153,5.456H47.014A3.624,3.624,0,0,0,50.154,111.966Zm5.757-34.2c-.013-.026-.026-.039-.039-.065l-3.049-5.3a.755.755,0,0,0-1.047-.314l-2.852,1.649a.75.75,0,0,0-.275,1.021l6.189,10.729a.75.75,0,0,0,1.021.275l2.879-1.675A.763.763,0,0,0,59,83.115Z",
    transform: "translate(-15.087 -70.427)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreats);
export default __webpack_public_path__ + "static/media/Threats.c644d57166519a1b573f8b0dc15e9750.svg";
export { ForwardRef as ReactComponent };